import styled from 'styled-components'

export default styled.div.attrs(() => ({
  id: 'error-message',
}))`
  ${(props) => props.marginTop && `margin-top: ${props.marginTop};`}
  ${(props) => props.marginRight && `margin-right: ${props.marginRight};`}
  ${(props) => props.marginBottom && `margin-bottom: ${props.marginBottom};`}
  ${(props) => props.marginLeft && `margin-left: ${props.marginLeft};`}

  /* Always white — text on filled danger background in both themes */
  color: #fff;
  font-size: 0.9em;
  padding: 10px 20px;
  background: var(--negative-color);
  border-radius: 10px;
`
